<script>
import { mapActions } from 'vuex';
import toggleModal from '@/mixins/toggleModal';

export default {
  props: {
    pageSize: {
      type: Number,
      required: true,
    },
    offset: {
      type: Number,
      required: true,
    },
  },
  mixins: [toggleModal],
  methods: {
    ...mapActions({
      createCategoryAction: 'promotions/createCategory',
    }),
    handleOk(values) {
      this.createCategoryAction({
        value: { name: values.name },
        params: {
          limit: this.pageSize,
          offset: this.offset,
        },
      });
      this.hideModal();
    },
  },
};
</script>

<template>
  <a-modal :open="show" :footer="null" @cancel="hideModal">
    <FormKit
      type="form"
      submit-label="Create"
      @submit="handleOk"
    >
      <h1 class="text-2xl font-bold mb-2">Create category</h1>
      <FormKit
        type="text"
        name="name"
        label="Name"
        placeholder="Enter name new category"
        validation="required"
      />
    </FormKit>
  </a-modal>
</template>

<style scoped lang="scss">

</style>
